import { v4 as uuidv4 } from 'uuid';

export const getUserId = (): string => {
  let id = localStorage.getItem('dwf_userId');
  if (!id) {
    id = uuidv4();
    localStorage.setItem('dwf_userId', id);
  }
  return id;
};

